/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_WALLET_BALANCE = gql`
query GetMyBalance {
    getMyBalance {
        address
        balance_in_crypto {
          ether {
            amount
          }
          matic {
            amount
          }
          wei {
            amount
          }
    etherOrMatic {
      amount
    }
    cryptoType
    cryptoSymbol
    
        }
        balance_in_fiat {
          INR
          USD
        }
        xchange_rates {
          INR
          USD
        }
        avlBalToWithdraw
        avlResellCredit
        provider_type
      }
  }
`